import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api/api.service';
import { usersList, get_sports_obj } from './panda-connect.model';
import { ToastService } from 'src/app/services/toast/toast.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CoachEmailRequest, InviteGroupEmailRequest } from '../profile/components/recommendations/recommendation.model';
@Injectable({
  providedIn: 'root',
})
export class PandaConnectBLL {
  //#region Loaders Observables

  private isLoading_users: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly isLoading_users$: Observable<boolean> =
    this.isLoading_users.asObservable();

  private sportsLoading: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly sportsLoading$: Observable<boolean> =
    this.sportsLoading.asObservable();

  private isLoading_sentCancelRequest: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly isLoading_sentCancelRequest$: Observable<boolean> =
    this.isLoading_sentCancelRequest.asObservable();

    private coachEmailLoading: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  readonly coachEmailLoading$: Observable<boolean> =
    this.coachEmailLoading.asObservable();

    private coachEmailStatus: BehaviorSubject<string> =
    new BehaviorSubject<string>(null);
  readonly coachEmailStatus$: Observable<string> =
    this.coachEmailStatus.asObservable();

  //#endregion Loaders Observables

  //#region Data Observables

  private users: BehaviorSubject<usersList> = new BehaviorSubject<usersList>(
    null
  );
  readonly users$: Observable<usersList> = this.users.asObservable();

  private sports: BehaviorSubject<get_sports_obj> =
    new BehaviorSubject<get_sports_obj>(null);
  readonly sports$: Observable<get_sports_obj> = this.sports.asObservable();

  //#endregion Data Observables

  constructor(private api: ApiService, private toast: ToastService, private auth: AuthService, private http: HttpClient) {}

  public get_users(
    search?: string,
    user_id?: string,
    city?: string,
    high_school?: string,
    club?: string,
    sat_score?: string,
    gpa?: string,
    birth_year?: string,
    high_school_grad_year?: string,
    state?: string,
    sports_id?: string,
    role_id?: string,
    position_id?: string,
    page: number = 1,
    limit: number = 100,
    club_id: string = '',
    verifier: boolean = false,
    weight: number = 0,
    height: number = 0
    
  ) {
    this.isLoading_users.next(true);
    let is_under_age = JSON.parse(localStorage.getItem('age')) && JSON.parse(localStorage.getItem('age')) <= 12;

    let url = `user?type=all_users&is_under_age=${is_under_age}&page=${page}&limit=${limit}`;

    if (search) {
      url += `&search=${search}`;
    }

    if (club_id) {
      url += `&club_id=${club_id}`;
    }

    if (user_id) {
      url += `&id=${user_id}`;
    }

    if (weight>0) {
      url += `&weight=${weight}`;
    }

    if (height>0) {
      url += `&height=${height}`;
    }

    if (city) {
      url += `&city=${city}`;
    }

    if (high_school) {
      url += `&high_school=${high_school}`;
    }

    if (club) {
      url += `&club=${club}`;
    }

    if (sat_score) {
      url += `&sat_score=${sat_score}`;
    }

    if (gpa) {
      url += `&gpa=${gpa}`;
    }

    if (birth_year) {
      url += `&birth_year=${birth_year}`;
    }

    if (high_school_grad_year) {
      url += `&high_school_grad_year=${high_school_grad_year}`;
    }

    if (state) {
      url += `&state=${state}`;
    }

    if (sports_id) {
      url += `&sports_id=${sports_id}`;
    }

    if (verifier) {
      url += `&verifier=paid`;
    }

    if (role_id) {
      url += `&role=${role_id}`;
    }

    if (position_id) {
      url += `&position_id=${position_id}`;
    }

    this.api
      .get(url)
      .pipe(take(1))
      .subscribe(
        (res: usersList) => {
          this.users.next(res);
          this.isLoading_users.next(false);
        },
        (err) => {
          console.log('err', err);
          this.users.next(null);
          this.isLoading_users.next(false);
        }
      );
  }

  public destructorUser (){
    this.users.next(null)
  }

  public async getSports() {
    this.sportsLoading.next(true);

    this.auth.auth$.pipe(take(1)).subscribe((user: any) => {
      if (user?.token) {
        let url = 'sports?type=get_all_sports';
        this.api
          .get(url)
          .pipe(take(1))
          .subscribe(
            (res: get_sports_obj) => {
              this.sports.next(res);
              this.sportsLoading.next(false);
            },
            (err) => {
              this.sportsLoading.next(false); 
            }
          );
      } else {
        let url = 'contracts?type=get_all_sports';
        this.http
          .get(environment.unauth_api_url + url)
          .pipe(take(1))
          .subscribe(
            (res: any) => {
              this.sports.next(res);
              this.sportsLoading.next(false);
            },
            (err) => {
              this.sportsLoading.next(false); 
            }
          );
      }
    });
  }

  public send_request(
    sender_id,
    receiver_id,
    status,
    sender_name,
    sender_display_picture,
    push_notification_id
  ) {
    // Debugging!!!!
    // console.log('sender_id', sender_id);
    // console.log('receiver_id', receiver_id);
    // console.log('status', status);

    this.isLoading_sentCancelRequest.next(true);
    let url = `community?type=request`;
    this.api
      .post(url, {
        sender_id,
        receiver_id,
        status,
        sender_name,
        sender_display_picture,
        push_notification_id,
      })
      .subscribe(async (response) => {
        this.update_status(
          this.users.getValue().users,
          receiver_id,
          response.response
        );
        this.toast.showToast('', response.message);
      });
    setTimeout(() => {
      this.isLoading_sentCancelRequest.next(false);
    }, 1000);
  }

  public update_status(users, receiver_id, response) {
    for (var i in users) {
      if (users[i].id == receiver_id) {
        if (response.status === 'cancel') {
          users[i].status = null;
        } else {
          users[i].status = response.status;
        }
        break;
      }
    }
  }

  public async sendCommunityInviteEmail(request: InviteGroupEmailRequest, group?: string) {
    this.coachEmailLoading.next(true);
    let apiUrl = 'community?type=invite_to_connect';
    if(group === 'group') {
      apiUrl = apiUrl + "&invited_from=group";
    }
    this.api
      .post(apiUrl, request)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          this.coachEmailStatus.next('email-success');
          this.toast.showToast(
            'Success!',
            `Email sent to ${request.receiver_email} successfully.`
          );
          this.coachEmailLoading.next(false);
        },
        (err) => {}
      );
  }

}
